export default __webpack_public_path__ + "media/images/user/history-ff7e7a0439f573b94cc0c3f9f5fab4e1.png";